import React from 'react';

import { Check } from 'lucide-react';
import { Link } from 'react-router';

import Pill, { DefaultPillStyles } from 'common/common/Pill';
import LazyLoadedImage from 'common/LazyLoadedImage';
import { Tag } from 'common/subdomain/admin/AdminIntegrationSettings/constants';
import ButtonV2 from 'common/ui/ButtonV2';
import Card from 'common/ui/Card';
import HStack from 'common/ui/HStack';
import VStack from 'common/ui/VStack';

type OnboardingIntegrationCardProps = {
  icon: string | React.ReactNode;
  title: string;
  description: string;
  href: string;
  isInstalled: boolean;
  tag: string | undefined;
  installButtonTitle: string | undefined;
};

const OnboardingIntegrationCard = ({
  icon: Icon,
  title,
  description,
  href,
  isInstalled,
  tag,
  installButtonTitle = 'Install',
}: OnboardingIntegrationCardProps) => {
  return (
    <Card className="px-4 py-3">
      <HStack className="items-center gap-3">
        {typeof Icon === 'string' ? (
          <LazyLoadedImage src={Icon} alt={title} height={38} width={38} />
        ) : (
          Icon
        )}
        <VStack className="flex-1 gap-1">
          <HStack className="items-center gap-1">
            <div className="text-body font-medium">{title}</div>
            {tag && (
              <Pill pillStyle={tag === Tag.beta ? DefaultPillStyles.beta : DefaultPillStyles.canny}>
                {tag}
              </Pill>
            )}
          </HStack>
          <div className="text-body text-gray-110">{description}</div>
        </VStack>
        <Link to={href} target={href.includes('https://') ? '_blank' : undefined}>
          <ButtonV2
            variant="outlined"
            size="small"
            startIcon={isInstalled ? Check : undefined}
            disabled={isInstalled}>
            {isInstalled ? 'Installed' : installButtonTitle}
          </ButtonV2>
        </Link>
      </HStack>
    </Card>
  );
};

export default OnboardingIntegrationCard;
